export default function checkZendesk(cb = () => {}) {
  if (typeof window.zE === "function") {
    cb();
  } else {
    setTimeout(() => checkZendesk(cb), 100);
  }
}
